import React from 'react';
import {TextField,makeStyles,createStyles} from '@material-ui/core'
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const useStyles = makeStyles(theme =>
    createStyles({
      inputs: {
        fontSize: 14,
        width:140
      },
      newPadding: {
        "& .MuiSelect-outlined": {
            padding: '8px 10px',
        }
      }
      
    })
  );
function SelectDetails(props) {
    const classes=useStyles()
    const onChangeHandle = (e)=>{
        props.onChangeMstate(true,{Meta:props.Meta,MetaN:props.MetaN,Value:e.target.value,Checked:true,Type:"ColumnH",isSwitch:true},5)
    }
    const GetLabel=()=>{
      switch(props.Meta){
        case "Typ": return props.intl.formatMessage({ id: 'Table.Type' });
        default: return props.Meta
      }
    }
    return (
        <div>
             <TextField
                variant="outlined"
                fullWidth                     
                label={`${GetLabel()}:`}
                className={classes.newPadding}
                size="small"
                name={`${props.MetaN}`}
                select
                //disabled={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))}
                //value={props.Mstate.filter(item=>{return item.Meta === props.MetaN})[0].Value}
                //value={0}
                value={isEmpty(props.Mstate.filter(item=>{return item.MetaN === props.MetaN}))?0:props.Mstate.filter(item=>{return item.MetaN === props.MetaN})[0].Value}
                SelectProps={{native: true,}}
                InputLabelProps={{shrink: true,}}
                InputProps={{className: classes.inputs}}
                onChange={onChangeHandle}
                >
                <option key={0} value={0}><IntlMessages id="Details"/></option>
                <option key={1} value={1}><IntlMessages id="Summarized"/></option>
            </TextField>  
        </div>
    );
}

export default injectIntl(SelectDetails);